// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"f1010eee","547":"b8d0c281"}[chunkId] + ".chunk.js";
};